// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import '../static/fonts/iconfont.css' // ruoyi css
import 'element-ui/lib/theme-chalk/index.css';

import "../static/css/npage.css"
import "../static/css/animate.min.css"
import "../static/css/bootstrap.min.css"
import "../static/css/open.css"
import "../static/css/style.css"

// 添加响应拦截器
// axios.interceptors.response.use((res) => {
//   // 对响应数据做点什么
//   console.log(res.data);
//   return res;
// }, function (error) {
//   // 对响应错误做点什么
//   return Promise.reject(error);
// });

var env = process.env.NODE_ENV;

Vue.config.productionTip = false
Vue.use(VueAxios, axios);
Vue.use(ElementUI);

Vue.prototype.$showService = true;
Vue.prototype.$apiUrl = env == 'development' ? "http://devopen.zonelink.cc" : "https://open.zonelink.cc";
Vue.prototype.$pageSizes = [10, 20, 50];
Vue.prototype.$showSuccessMsg = function (msg) {
  this.$notify({
    type: "success",
    title: "通知：",
    message: msg,
    position: 'bottom-right',
    duration: 2000
  });
}
Vue.prototype.$showWarnMsg = function (msg) {
  this.$notify({
    type: "warning",
    title: "错误提示：",
    message: msg,
    position: 'bottom-right',
    duration: 2000
  });
};
Vue.prototype.$showErrorMsg = function (msg) {
  this.$notify({
    type: "error",
    title: "错误提示：",
    message: msg,
    position: 'bottom-right',
    duration: 2000
  });
};

Vue.prototype.$dateQuickPickerOptions = {
  shortcuts: [{
    text: '最近一周',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      picker.$emit('pick', [start, end]);
    }
  }]
}

Vue.prototype.$printTags = [{
  label: "<ZLY>",
  tips: "众联云助手微信公众号二维码"
}, {
  label: "<WDM>",
  tips: "五斗米助手微信公众号二维码"
}, {
  label: "<PLMC>xx</PLMC>",
  tips: "语音播报，c1:新订单，c4:催单，c5:申请取消订单，c6:订单已取消，c7:订单已退款，c8:待处理预约单，cb新的消息提醒"
}, {
  label: "<BR>",
  tips: "换行符"
}, {
  label: "<LINE->",
  tips: "分隔符“-”，自适应纸宽，效果 --------------------------------"
}, {
  label: "<LINE*>",
  tips: "分隔符“*”，自适应纸宽，效果 ********************************"
}, {
  label: "<LINE#>",
  tips: "分隔符“#”，自适应纸宽，效果 ################################"
}, {
  label: "<LINE=>",
  tips: "分隔符“=”，自适应纸宽，效果 ================================"
}, {
  label: "<TITLE>xx</TITLE>",
  tips: "标题，自适应纸宽，效果 ------------- 备注 -------------"
}, {
  label: "<GROUP>xx</GROUP>",
  tips: "分组，配合下面的<LINE>配合使用，效果     鸡扒饭     x1  ￥15.8元"
}, {
  label: "<LINE>xx</LINE>",
  tips: "占满一行的条目数据，配合下面的<ITEM>配合使用，譬如：<LINE><ITEM>鸡扒饭</ITEM><ITEM>x1</ITEM><ITEM>￥15.8元</ITEM></LINE>"
}, {
  label: "<ITEM>xx</ITEM>",
  tips: "行数据条目，譬如：<ITEM>鸡扒饭</ITEM><ITEM>x1</ITEM><ITEM>￥15.8元</ITEM>"
}, {
  label: "<CUT>",
  tips: "自动切纸（仅限切刀设备使用才有效果）"
}, {
  label: "<C></C>",
  tips: "居中，自动换行不用跟着加<BR>"
}, {
  label: "<RIGHT></RIGHT>",
  tips: "右对齐，自动换行不用跟着加<BR>"
}, {
  label: "<M></M>",
  tips: "中号字体"
}, {
  label: "<CM></CM>",
  tips: "居中 + 中号字体，自动换行不用跟着加<BR>"
}, {
  label: "<B></B>",
  tips: "大号字体"
}, {
  label: "<CB></CB>",
  tips: "居中 + 大号字体，自动换行不用跟着加<BR>"
}, {
  label: "<W></W>",
  tips: "倍宽"
}, {
  label: "<CW></CW>",
  tips: "居中 + 倍宽，自动换行不用跟着加<BR>"
}, {
  label: "<BOLD></BOLD>",
  tips: "字体加粗，标签嵌套的时候需要放在最内层，如：<CB><BOLD>众联云</BOLD></CB>"
}, {
  label: "<REV></REV>",
  tips: "黑白反打"
}, {
  label: "<QRCODE></QRCODE>",
  tips: "二维码"
}, {
  label: "<BARCODE></BARCODE>",
  tips: "条形码"
}, {
  label: "<HP>",
  tips: "好评图片"
}, {
  label: "<517>",
  tips: "伍幺柒外卖LOGO"
}, {
  label: "<JDWM>",
  tips: "京东外卖LOGO"
}];

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js